 import React from "react";

import { RiskAssessmentPageShell } from "./RiskAssessmentPageShell";
import { useRiskAssessmentController } from "./useRiskAssessmentController";

export const RiskAssessmentForm: React.FC<{ hideHeader?: boolean; readOnly?: boolean }> = (props) => {
  const controller = useRiskAssessmentController(props);

  return <RiskAssessmentPageShell controller={controller} />;
};
